import React from "react";
import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";
import "./bottomFixedNotification.scss";

type Props = {
  isShow: boolean;
  hideModal: () => void;
  className?: string;
  buttonNames: [string] | [string, string];
  clickEvents?: [any] | [any, any];
  title: string;
  subscribe: string;
  emoji?: string;
  children?: any;
};
const BottomFixedNotification = ({
  isShow,
  hideModal,
  className,
  buttonNames,
  clickEvents,
  title,
  subscribe,
  emoji = "",
  children,
}: Props) => {
  return (
    <BottomFixedModal
      className={`bottom-notification ${className} ${emoji ? "modal-has-emoji" : ""}`}
      isShow={isShow}
      isTransition={true}
      hideModal={hideModal}
      title={emoji ? emoji : title}
    >
      <div>
        {emoji && <h2 className="title-has-emoji bold">{title}</h2>}
        {children ? <>{children}</> : <div className="modal-subscribe">{subscribe}</div>}
        <div className="bottom-notification-btn-wrap">
          {buttonNames.map((name, idx) => (
            <button
              key={`btn-key-${idx}`}
              className={`btn btn-full btn-giant btn-red500`}
              onClick={clickEvents[idx]}
            >
              {name}
            </button>
          ))}
        </div>
      </div>
    </BottomFixedModal>
  );
};

export default BottomFixedNotification;
